import { SELECT_EVENT, DESELECT_EVENT, DESELECT_TRACK, SELECT_EVENTCLASS, SELECT_TRACK, DESELECT_EVENTCLASS
    , GET_EVENTS, SELECT_COMPETITOR, DESELECT_COMPETITOR, SELECT_ITEM
    , GOT_TIMESTAMP} from '../actions/types'

const initialState = {events: []}

// const prevCheckPointId = (list, id) => {
//     const idx = prevIndexOf( list, id)
//     return list[idx].sequence
// }
// const nextCheckPointId = (list, id) => {
//     const idx = nextIndexOf( list, id)
//     return list[idx].sequence
// }

export default function( state = initialState, action){
    let eventId = 0
    let trackId = 0
    let eventClassId = 0
    let competitorId = 0
    let checkPointId = 0
    let clubId = 0
    // let idx = -1

    switch( action.type){

        case GOT_TIMESTAMP: 
        let updateEvents = false
        action.payload.forEach( (item) => {
            let [mapAsArray] = Object.entries( item)
            const eventInState = state.events.find( (e) => e.id === parseInt( mapAsArray[0], 10))
            if( !eventInState){
                updateEvents = true
            }
            else if( !eventInState.lastModified){
                updateEvents = true
            }
            else if( eventInState.lastModified < mapAsArray[1]){
                updateEvents = true
            }

        })
        return {
            ...state
            , updateEvents : updateEvents 
        }
        case GET_EVENTS:
            if( state.event === undefined){
                return {
                    ...state
                    , event: action.payload.events[0]
                    , events: action.payload.events
                    , currEventID : action.payload.events[0].id
                    , currTrackID : action.payload.events[0].tracks[0].id
                    , currEventClassID : null
                    , currCheckPointID: 0
                    , updateEvents: false
                }
            }
            else
                return {
                    ...state
                    , event: action.payload.events[0]
                    , events: action.payload.events
                    , updateEvents: false
                }

        case SELECT_EVENT: 
        return {
            ...state
            , currEventID: action.payload.event.id
            , event: action.payload.event
        }

        case SELECT_TRACK: 
        return {
            ...state
            , track: action.payload.track
            , currTrackID: action.payload.track.id
            , currEventClassID: null
            , currCompetitorID: null
            , currCheckPointID: 0
            , currClubID: null
        }
        case SELECT_ITEM:
            eventId = state.currEventID
            trackId = state.currTrackID
            eventClassId = state.currEventClassID
            checkPointId = state.currCheckPointID
            competitorId = state.currCompetitorID
            clubId = state.currClubID
            // idx = -1

            switch (action.payload.type) {

                case 'track':
                    // idx = indexOf( state.event.tracks, action.payload.id)
                    // if( idx > -1) {
                    eventClassId = 0
                    trackId = action.payload.id
                    // }
                    break
                case 'eventClass':
                    eventClassId = action.payload.id
                    break
                case 'checkPoint':
                    checkPointId = action.payload.id
                    break
                default:
                    break
            }
            return {
                ...state
                , currEventID: eventId
                , currTrackID: trackId
                , currEventClassID: eventClassId
                , currCompetitorID: competitorId
                , currCheckPointID: checkPointId
                , currClubID: clubId
        }

        case SELECT_COMPETITOR: 
        return {
            ...state
            , competitor: action.payload.competitor
            // , currCompetitorID: action.payload.competitor.id
        }

        case SELECT_EVENTCLASS: 
        return {
            ...state
            // , currTrackID: state.event.eventClasses[ indexOf(state.event.eventClasses, action.payload)].track.id
            , currEventClassID: action.payload
        }

        // case SELECT_TRACK:
        // return {
        //     ...state
        //     , currTrackID: action.payload.track.id
        // }

        // case SELECT_COMPETITOR:
        // return {
        //     ...state
        //     , currCompetitorID: action.payload.competitor.id
        // }

        case DESELECT_COMPETITOR: 
        return {
            ...state
            , currCompetitorID: null
        }

        case DESELECT_EVENT: 
        return {
            ...state
            , currEventID: null
            , currTrackID: null
            , currEventClassID: null
            , currCompetitorID: null
        }

        case DESELECT_EVENTCLASS: 
        return {
            ...state
            , currCompetitorID: null
            , currEventClassID: null
        }

        case DESELECT_TRACK: 
        return {
            ...state
            , currTrackID: null
            , currCompetitorID: null
            , currEventClassID: null
        }

        default : 
            return state
    }
}